import { render, staticRenderFns } from "./MediaList.vue?vue&type=template&id=a937912a&"
import script from "./MediaList.vue?vue&type=script&lang=js&"
export * from "./MediaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports